<template>
  <div>
    <label for="basicInfoQuestionSelect">{{ label }}</label>
    <!-- <div v-if="singleForm" id="basicInfoQuestionSelect" class="d-flex flex-wrap justify-content-between" :dreams-id="question.attributes[0].alias">
      <button
        class="single-form-selection-pill text-center p-sm rounded py-4 px-3 mb-1 bg-white"
        v-bind:class="{
          'selection-pill--selected': checkIfOptionSelected(option),
          'selection-pill--focused': option.focused,
          'selection-pill--invalid': v$.attr.$error,
        }"
        v-for="(option, index) in options"
        @focus="onFocus(option)"
        @blur="onBlur(v$, option)"
        @click="selectOption(option, $event)"
        @keydown.space="selectOption(option, $event)"
        @invalidity="$emit('invalidity', $event)"
        :key="index">
        {{ option.button || option.label }}
      </button>-->
      <!-- These empty option boxes are to set a fixed left alignment on the bottom row -->
      <!-- <span v-if="options.length > 4" class="flex-spacer"></span>
      <span v-if="options.length > 4" class="flex-spacer"></span>
      <span v-if="options.length > 4" class="flex-spacer"></span> -->
      <!-- These empty option boxes are to set a fixed left alignment on the bottom row -->

      <!--<slot name="helpText"><div class="ba-help-text mb-2" :class="{ 'mb-2': errorText || disclaimer }" v-if="helpText" v-html="helpText"></div></slot>
      <slot name="errorText"><div class="ba-error-message mb-2 invalid-feedback d-block" :class="{ 'mb-2': disclaimer }" v-if="errorText" v-html="errorText"></div></slot>
      <slot name="disclaimer"><div class="ba-disclaimer" v-if="disclaimer" v-html="disclaimer"></div></slot>
    </div> -->
    <div id="basicInfoQuestionSelect" class="container px-3 pt-3" :dreams-id="question.attributes[0].alias">
      <div
        class="row gap-2"
        :class="{
          'row-cols-3': questionAlias !== 'entity_type',
          'row-cols-2': questionAlias === 'entity_type'
        }"
      >
        <button
          :id="'biqs-' + index"
          class="selection-pill type-400 p-sm text-center py-0 px-2 bg-white rounded col"
          :class="{
            'entity-type-btn': questionAlias === 'entity_type',
            'selection-pill--selected': checkIfOptionSelected(option),
            'selection-pill--focused': option.focused,
            'selection-pill--invalid': v$.attr && v$.attr.$error,
          }"
          v-for="(option, index) in options"
          @click="selectOption(option, $event)"
          @focus="onFocus(option)"
          @blur="onBlur(v$, option)"
          @keydown.space="selectOption(option, $event)"
          :key="index">
          {{ option.button || option.label }}
        </button>
      </div>
      <small class="invalid-feedback" v-if="v$.attr && v$.attr.$error">
        <i class="fa-light fa-circle-exclamation"></i> {{ errorText }}
      </small>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useQuestionsStore } from '~/store/questions'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'

export default {
  emits: ['invalidity', 'answer'],
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      attr: this.initializeFromQuestion(),
      options: cloneDeep(
        (this.question.directiveMapping && this.question.directiveMapping.options)
        || this.question.attributes[0].options
      ),
      errorMessage: 'Please select an option',
    }
  },
  created: function() {
    this.$watch('v$.$invalid', (invalid) => {
      this.$emit('invalidity', invalid)
    }, {immediate: true})
  },
  computed: {
    ...mapState(useQuestionsStore, {
      singleForm: store => get(store, 'singleForm'),
      validateSingleForm: store => get(store, 'validateSingleForm'),
    }),
    questionAlias() {
      return this.question.attributes[0].alias
    },
    label() {
      if (this.question.attributes[0].alias === 'entity_type') {
        return "What type of entity is your business?"
      } else if (this.question.attributes[0].alias === 'fundAspect') {
        return "Which is most important to you?"
      }
      return this.question.attributes[0].name || ''
    },
    helpText() {
      return this.question.tooltip ? this.question.helpText : ''
    },
    errorText() {
      let errorTxt = ''
      const err = get(this.v$, 'attr.$error')
      if (err && this.question.alias === 'borrower.stateId') {
        errorTxt = 'Please select a state'
      } else if (err && this.question.alias === 'businessType') {
        errorTxt = 'Please select a business type'
      } else if (err) {
        errorTxt = this.errorMessage ? this.errorMessage : 'Please select a value'
      }
      return errorTxt
    },
    disclaimer() {
      return this.question.disclaimer || ''
    },
    noneFocused() {
      return this.options.filter(o => o.focused === true).length === 0
    }
  },
  validations: {
    attr: {
      value: { required }
    }
  },
  methods: {
    setValue (option) {
      this.attr.value = option.value
      this.answer()
    },
    selectOption (option, event) {
      if (event) {
        event.preventDefault()
      }
      if (!this.checkIfOptionSelected(option)) { // This allows us to preserve their value if they click the same button and have a different value rather than clicking next
        this.setValue(option)
      } else {
        this.answer()
      }
    },
    checkIfOptionSelected (option) {
      let parsedValue = parseFloat(this.attr.value)
      let range

      if (!isNaN(parsedValue) && option.range) {
        range = JSON.parse(option.range)
      } else {
        return this.attr.value === option.value
      }

      if (range[1] === 'INFINITY') {
        range[1] = Infinity
      }

      if (!isNaN(range[0]) && !isNaN(range[1])) {
        return (parsedValue >= range[0] && parsedValue <= range[1])
      }
      return false
    },
    answer () {
      this.$emit('answer', { attr: [this.attr], submitImmediately: true}) // set true by default
    },
    initializeFromQuestion () {
      return {
        alias: this.question.attributes[0].alias,
        value: this.question.attributes[0].value
      }
    },
    onFocus (option) {
      option['focused'] = true
    },
    onBlur (v$, option) {
      option['focused'] = false
      setTimeout(() => {
        if (this.noneFocused) {
          v$.$touch()
        }
      }, 0)
    },
  },
  props: {
    question: Object,
    invalidity: Object,
  },
  watch: {
    question: {
      deep: true,
      // This cannot be an arrow function or it won't have reference to methods
      handler: function (newVal, oldVal) {
        this.attr = this.initializeFromQuestion()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.selection-pill {
  width: 31%;
  @include media-breakpoint-up(lg) {
    width: 112px;
  }
  max-width: 112px;
  height: 48px;
  border: 1px solid $border-300;
  cursor: pointer;
}

.entity-type-btn {
  width: 48%;
  max-width: 172px;
}

.single-form-selection-pill {
  width: 150px;
  @include media-breakpoint-down(sm) {
    width: 47%
  }
  border: 1px solid $border-200;
  cursor: pointer;
}
.selection-pill--focused {
  box-shadow: 0 0 0 0.25rem $background-200;
}
.selection-pill--selected {
  border: 2px solid $blue-300;
}
.selection-pill--invalid {
  border-color: $danger;
}
.flex-spacer {
  flex-basis: 150px;
  height: 0;
  margin: 0;
}
</style>
